import { CheckOnlyPermission, Permission } from './schema'

export const TradingPermissions = {
  // Order permissions
  TRADE_READ: [Permission.OMSOrderReadAll],
  TRADE_READ_ANY: [CheckOnlyPermission.OMSOrderReadAny],
  TRADE_CREATE: [Permission.OMSOrderCreate],
  ADVISOR_TRADE_CREATE: [Permission.AOMSOrderCreate],
  /**
   * Creating an order from either origin: `oms::order::create` for a trader,
   * `aoms::order::create` for an advisor. **Check with mode `'any'`** — the
   * default `'all'` would demand both grants and permit nobody.
   */
  TRADE_CREATE_ANY_ORIGIN: [
    Permission.OMSOrderCreate,
    Permission.AOMSOrderCreate,
  ],
  TRADE_CANCEL: [Permission.OMSOrderCancel],
  /**
   * Canceling an order from either origin: `oms::order::cancel` for a trader,
   * `aoms::order::cancel` for an advisor canceling in their own blotter. **Check
   * with mode `'any'`** — the default `'all'` would demand both grants and permit
   * nobody.
   */
  TRADE_CANCEL_ANY_ORIGIN: [
    Permission.OMSOrderCancel,
    Permission.AOMSOrderCancel,
  ],
  /** Canceling a filled execution (a trade cancel), not the order itself. */
  TRADE_EXECUTION_CANCEL: [Permission.OMSTradeCancel],
  TRADE_UPDATE: [Permission.OMSOrderUpdate],
  TRADE_MANUAL_REVIEW: [Permission.OMSOrderManualReview],
  /**
   * Trading equities and funds; orders-api rejects both without it. Fixed
   * income needs only `TRADE_CREATE`.
   */
  TRADE_ASSET_CLASS_EQUITY: [Permission.OMSAssetClassTradeEquity],

  /**
   * Creating a post-trade allocation. Provisional: the v2 allocate endpoint
   * doesn't exist yet, so this points at v1's allocation-create grant
   * (`pms::allocation::create`) — revisit against the real endpoint's
   * permission when it lands.
   */
  TRADE_ALLOCATION_CREATE: [Permission.PMSAllocationCreate],

  // Execution instruction permissions
  TRADE_EXECUTION_INSTRUCTION_CREATE: [
    Permission.OMSExecutionInstructionCreate,
  ],
  TRADE_EXECUTION_INSTRUCTION_CANCEL: [
    Permission.OMSExecutionInstructionCancel,
  ],

  // Inquiry IOI permissions
  /** Confirming the final price on an IOI the caller owns. */
  INQUIRY_IOI_APPROVE_PRICE_SELF: [Permission.OMSInquiryIOIApprovePriceSelf],
  /** The same confirmation, on any advisor's IOI. */
  INQUIRY_IOI_APPROVE_PRICE_ALL: [Permission.OMSInquiryIOIApprovePriceAll],

  // Inquiry quote-wanted permissions
  /**
   * Quoting a price back on an advisor quote-wanted inquiry. Unscoped: the
   * trader answers any advisor's inquiry.
   */
  INQUIRY_QUOTE_WANTED_QUOTE_PRICE: [
    Permission.OMSInquiryQuoteWantedQuotePrice,
  ],
  /** Accepting or rejecting a quoted price on a quote wanted the caller owns. */
  INQUIRY_QUOTE_WANTED_APPROVE_PRICE_SELF: [
    Permission.OMSInquiryQuoteWantedApprovePriceSelf,
  ],
  /** The same answer on any advisor's quote wanted, so no ownership check. */
  INQUIRY_QUOTE_WANTED_APPROVE_PRICE_ALL: [
    Permission.OMSInquiryQuoteWantedApprovePriceAll,
  ],

  // Execution rules permissions
  EXECUTION_RULES_READ: [Permission.OMSExecutionRulesetRead],
  EXECUTION_RULES_WRITE: [Permission.OMSExecutionRulesetWrite],
  EXECUTION_RULES_FOR_ORG_WRITE: [Permission.OMSExecutionRulesetForOrgWrite],

  // Inquiry pricing rules permissions
  INQUIRY_PRICING_RULES_READ: [Permission.OMSInquiryPricingRulesetRead],
  INQUIRY_PRICING_RULES_WRITE: [Permission.OMSInquiryPricingRulesetWrite],

  // RFQ permissions
  RFQ_READ: [Permission.RFQRead],
  RFQ_CREATE: [Permission.RFQCreate],
  RFQ_CANCEL: [Permission.RFQCancel],

  // Best Execution
  BEST_EXECUTION: [Permission.BestExecutionAccess],

  // LPL edit check permissions
  LPL_EDIT_CHECK_READ: [Permission.LPLEditCheckRead],
  LPL_EDIT_CHECK_CREATE: [Permission.LPLEditCheckCreate],
}
